var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.finishGetList)?_c('div',{staticClass:"empty_wrap min_height mt50"}):_c('div',{directives:[{name:"loading",rawName:"v-loading",value:(!_vm.finishGetList),expression:"!finishGetList"}],staticClass:"empty_wrap min_height",attrs:{"element-loading-text":'',"element-loading-custom-class":"dgmong_loading"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }